import React from 'react';
import PropTypes from 'prop-types';
import TransactionKey from "../Display/TransactionKey";
import Date from "components/Display/ViewDate";
import Amount from "components/Display/Amount";


const CostSettingTable = ({ data }) => {

  if (!data.costs){
    return (
      <div/>
    );
  }

  let costs = data.costs;
  return (
    <div className="calc-setting-table">
        <table className="table">
          <colgroup>
            <col />
            <col />
            <col />
          </colgroup>
          <thead>
          <tr>
            <th colSpan="3" className="text-left calc-setting-table-header">Kostnaður</th>
          </tr>
          <tr>
            <th className="text-left">Færslulykill</th>
            <th className="text-right">Dagsetning</th>
            <th className="text-right">Upphæð</th>
          </tr>
          </thead>
          <tbody>
          {costs.map(function(item,i){
            return(
              <tr key={i}>
                <td className="text-left"><TransactionKey data={item.transactionKey}/></td>
                <td className="text-right"><Date data={item.dueDate}/></td>
                <td className="text-right"><Amount data={item.amount}/></td>
              </tr>);
          })}
          </tbody>
        </table>
    </div>
  );
};

CostSettingTable.propTypes = {
  data: PropTypes.object,
};

export default CostSettingTable;



// WEBPACK FOOTER //
// ./src/pages/Calculation/Settings/CostSettingTable.js